import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=749df450&"
import script from "./svg-icon.vue?vue&type=script&lang=ts&"
export * from "./svg-icon.vue?vue&type=script&lang=ts&"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=749df450&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports